import React from "react";
import "./VisionMission.css";

const VisionMission: React.FC = () => {
  return (
    <section className="vm-section">
      <div className="container">
        <div className="vm-header">
          <span className="section-label">Our Foundation</span>
          <h2 className="section-title">Vision & Mission</h2>
        </div>
        <div className="vm-grid">
          <div className="vm-card vm-card--vision">
            {/* <div className="vm-card__icon">🔭</div> */}
            <h3 className="vm-card__title">Our Vision</h3>
            <p className="vm-card__text">
              To become a globally recognized technology company delivering
              innovative, scalable, and reliable digital solutions that help
              businesses grow and succeed in the digital era.
            </p>
            <div className="vm-card__line" />
          </div>
          <div className="vm-card vm-card--mission">
            {/* <div className="vm-card__icon">🎯</div> */}
            <h3 className="vm-card__title">Our Mission</h3>
            <p className="vm-card__text">
              To provide high-quality IT solutions using modern technologies,
              innovative ideas, and efficient development processes while
              maintaining long-term relationships with our clients.
            </p>
            <div className="vm-card__line" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
